const generateNumericArray = value =>
  Array.from({ length: value }, (v, k) => ({
    data: (k + 1).toString(),
    label: (k + 1).toString(),
  }));

export default generateNumericArray;
